(function(){
    'use strict'

    angular
    .module('app.eventos')
    .controller('eventos.List', List);

    List.$inject = ['$animationsSrv', 'ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment', 'pagosOnlineEnable'];

    function List($animationsSrv, ApiBaseService, logger, $location, UserInfoService, moment, pagosOnlineEnable) {
    
        $animationsSrv.scrollToTop();

        const MONEDA_COLONES = 1;
        const MONEDA_DOLARES = 2;

        var permisosEventos = UserInfoService.getPermisosEventos();

        var vm = this;

        vm.data = {
            categoriaId: 0,
            ordenReporte: 0,
            horaSalida: moment().toDate(),
            horaSalida2: moment().toDate(),
            horaSalida3: moment().toDate(),
            horaSalida4: moment().toDate(),
            horaSalida5: moment().toDate(),
            horaSalida6: moment().toDate(),
            horaSalida7: moment().toDate(),
            horaSalida8: moment().toDate(),
            horaSalida9: moment().toDate(),
            horaSalida: moment().toDate()
        }

        vm.uiData = {
            puedeGuardar: permisosEventos.guardar === true,
            puedeModificar: permisosEventos.modificar === true,
            puedeEliminar: permisosEventos.eliminar === true,
            esOrganizador: UserInfoService.esOrganizador(),
            agregandoCategoria: false,
            descargoData: {
                inscripcionId: 0,
                eventoId: 0,
                aceptaDescargo: false
            }
        };

        vm.collection = [];
        vm.title = 'Eventos';

        vm.categorias = [];

        if(vm.uiData.esOrganizador)
        {
            getComboData(vm.categorias, 'api/Categorias/All', null, 'Error al cargar las categorias')
            .then(function(){
                if(vm.categorias.length > 0)
                {
                    vm.data.categoriaId = vm.categorias[0].id;
                }
            });
        }

        vm.goToEdit = function(data){
            
            var path = '/editar-evento/';

            if(data){
                $location.path(path + data.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.verInscritosCategoria = function(data){
            
            var path = '/ver-inscritos-evento/';

            if(data){
                $location.path(path + data.id + '/'  + data.categoriaEnInscripcion.id
                );
            }
            
        };

        vm.verTodosLosInscritos = function(data){
            
            var path = '/ver-inscritos-evento/';

            if(data){
                $location.path(path + data.id);
            }
            
        };

        vm.goToInscripcion = function(data){
            
            var path = '/crear-inscripcion/' + data.id;

            $location.path(path);
            
        };

        vm.goToConfirmarPago = function(data){
            
            var path = '';

            if(pagosOnlineEnable) {
                path = '/editar-pago-v2/' + data.inscripcionId;
            }
            else {
                path = '/editar-pago/' + data.inscripcionId;
            }

            $location.path(path); 
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        vm.openModalWithData = function(modalName, evento){
            vm.uiData.descargoData.inscripcionId = evento.inscripcionId;
            vm.uiData.descargoData.id = evento.id;

            $(modalName).modal('toggle');    
        };

        vm.getMonedaSymbol = function(monedaId)
        {
            switch (monedaId) {
                case MONEDA_COLONES:
                    return '₡';
                case MONEDA_DOLARES:
                    return '$';
                default:
                    return '';
            }
        }

        function getRemoteController()
        {
            if(UserInfoService.esOrganizador())
            {
                return 'api/Eventos/All/true';
            }

            return 'api/Eventos/Usuario';
        }

        getAll();

        function getAll(){
            ApiBaseService.remoteController = getRemoteController();
            var promise = ApiBaseService.getAll([]);

            promise
            .then(function(collection){

                collection.forEach((c)=>{
                    c.verCategorias =  false;
                    c.verPaquetes =  false;
                    c.categorias = null
                });

                vm.collection = collection;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };

        vm.delete = function(data){
            ApiBaseService.remoteController = 'api/Eventos';
            var promise = ApiBaseService.remove(data);
            
            promise
            .then(function(response){
                vm.collection = vm.collection.filter(function(g) {
                    return g.id !== data.id;
                });
                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

        vm.getCategorias = function(item)
        {
            if(!item.categorias)
            {
                item.categorias = [];
                getComboData(item.categorias, 'api/EventosCategorias', [item.id], 'Error al obtener las categorias.')
                .then(()=>{
                    item.categorias.forEach((i)=>{
                        i.modificandoCategoria = false;
                    });
                });
            }
        };

        vm.saveCategoria = function(item){

            if(validateCreateCategoria(item))
            {
                createCategoria(item);
            }
        };

        vm.editarCategoria = function(item, evento){

            updateCategoria(item, evento);
        };

        function validateCreateCategoria(item)
        {
            let result = true;
            if(item.categorias.length > 0)
            {
                item.categorias.forEach((c)=>{
                    if(c.categoriaId === vm.data.categoriaId)
                    {
                        result = false;
                    }
                });
            }

            if(!result)
            {
                logger.error('La categoria ya esta asociada al evento');
            }
            
            return result;
        }

        function createCategoria(item) {
            ApiBaseService.remoteController = 'api/EventosCategorias';

            const data = {
                id: 0,
                eventoId: item.id,
                categoriaId: vm.data.categoriaId,
                horaSalida: vm.data.horaSalida,
                horaSalida2: item.dias >= 2 ? vm.data.horaSalida2 : null,
                horaSalida3: item.dias >= 3 ? vm.data.horaSalida3 : null,
                horaSalida4: item.dias >= 4 ? vm.data.horaSalida4 : null,
                horaSalida5: item.dias >= 5 ? vm.data.horaSalida5 : null,
                horaSalida6: item.dias >= 6 ? vm.data.horaSalida6 : null,
                horaSalida7: item.dias >= 7 ? vm.data.horaSalida7 : null,
                horaSalida8: item.dias >= 8 ? vm.data.horaSalida8 : null,
                horaSalida9: item.dias >= 9 ? vm.data.horaSalida9 : null,
                horaSalida10: item.dias >= 10 ? vm.data.horaSalida10 : null,
                ordenReporte: vm.data.ordenReporte
            };

            var promise = ApiBaseService.save(data);
            
            promise
            .then(function(response){

                if(response.data.command.success)
                {
                    vm.uiData.agregandoCategoria = false;
                    item.categorias = [];
                    getComboData(item.categorias, 'api/EventosCategorias', [item.id], 'Error al obtener las categorias.');
                }
                else
                {
                    logger.error('Hubo un error al agregar la categoria: ' + response.data.command.message);
                }
                
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateCategoria(item, evento) {
            ApiBaseService.remoteController = 'api/EventosCategorias';

            item.horaSalida2 = evento.dias >= 2 ? item.horaSalida2 : null;
            item.horaSalida3 = evento.dias >= 3 ? item.horaSalida3 : null;
            item.horaSalida4 = evento.dias >= 4 ? item.horaSalida4 : null;
            item.horaSalida5 = evento.dias >= 5 ? item.horaSalida5 : null;
            item.horaSalida6 = evento.dias >= 6 ? item.horaSalida6 : null;
            item.horaSalida7 = evento.dias >= 7 ? item.horaSalida7 : null;
            item.horaSalida8 = evento.dias >= 8 ? item.horaSalida8 : null;
            item.horaSalida9 = evento.dias >= 9 ? item.horaSalida9 : null;
            item.horaSalida10 = evento.dias >= 10 ? item.horaSalida10 : null;

            var promise = ApiBaseService.update(item);
            
            promise
            .then(function(response){

                if(response.data.command.success)
                {
                    item.modificandoCategoria = false;
                }
                else
                {
                    logger.error('Hubo un error al modificar la categoria: ' + response.data.command.message);
                }
                
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        vm.deleteCategoria = function(item, data){
            ApiBaseService.remoteController = 'api/EventosCategorias';
            var promise = ApiBaseService.remove(data);
            
            promise
            .then(function(response){
                item.categorias = item.categorias.filter(function(g) {
                    return g.id !== data.id;
                });
                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        vm.aceptarDescargo = function(){
            ApiBaseService.remoteController = 'api/Inscripciones/AceptaDescargo';

            vm.uiData.descargoData.aceptaDescargo = true;

            var promise = ApiBaseService.update(vm.uiData.descargoData);
            
            promise
            .then(function(response){
                vm.collection.forEach(function(element) {
                    if(element.inscripcionId === response.data.object.id)
                    {
                        element.aceptaDescargo = response.data.object.aceptaDescargo;                   
                    }
                });

                vm.uiData.descargoData.inscripcionId = 0;
                vm.uiData.descargoData.eventoId = 0;
                vm.uiData.descargoData.aceptaDescargo = 0;

                logger.success('Registro modificado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

    }
})();